import { computed, type ComputedRef } from 'vue';

let sequence = 0;

export default function createComponentId(prefix: string): ComputedRef<string> {
    sequence += 1;
    const id = `${prefix}-${sequence}`;
    return computed(() => id);
}
